import { Component, OnInit, Input, ViewChild, TemplateRef } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap';
import { ToasterService } from 'angular2-toaster';
import { TelecallerMasterService } from '../../../services/index';
import { AddEditTelecallerComponent } from './addEditTelecaller.component';

@Component({
    selector: 'telecaller-master-tab',
    templateUrl: './telecallerMaster.component.html'
})
export class TelecallerMasterComponent implements OnInit {
    @Input('tabTitle') title: string;
    @Input() active = false;
    @Input() isCloseable = false;
    @Input() dataContext;

    @ViewChild('telecallerTable') telecallerTable: any;
    @ViewChild('snoTemplate') snoTemplate: TemplateRef<any>;
    @ViewChild('editTemplate') editTemplate: TemplateRef<any>;
    @ViewChild('slotTemplate') slotTemplate: TemplateRef<any>;
    @ViewChild('teamTemplate') teamTemplate: TemplateRef<any>;
    @ViewChild('statusTemplate') statusTemplate: TemplateRef<any>;
    @ViewChild('filterPanel') filterPanel;

    columns = [];
    telecallerList: any[] = [];
    isLoadMask: Promise<any>;
    loadingIndicator = true;
    reorderable = true;
    bsModalRef: BsModalRef;

    filterData = { search_data: '' };

    page = {
        limit: 25,
        count: 0,
        offset: 0,
        orderBy: 'um.userid',
        orderDir: 'asc'
    };

    slotColors = {
        'Telecaller 1': '#3f51b5',
        'Telecaller 2': '#8e24aa',
        'Telecaller 3': '#e65100'
    };

    constructor(
        private telecallerMasterService: TelecallerMasterService,
        private modalService: BsModalService,
        private toasterService: ToasterService
    ) { }

    ngOnInit(): void {
        this.columns = [
            { name: 'SNo', prop: 'sno', width: 60, minWidth: 60, maxWidth: 60, cellClass: 'cell-center', sortable: false, cellTemplate: this.snoTemplate },
            { name: 'Telecaller Slot', prop: 'telecaller_slot', width: 150, minWidth: 150, maxWidth: 150, cellTemplate: this.slotTemplate },
            { name: 'Followup Team', prop: 'team_name', width: 140, minWidth: 140, maxWidth: 140, cellTemplate: this.teamTemplate },
            { name: 'Username', prop: 'username', width: 140, minWidth: 140, maxWidth: 140 },
            { name: 'Full Name', prop: 'fullname', width: 160, minWidth: 160, maxWidth: 160 },
            { name: 'Employee Name', prop: 'emp_display', width: 220, minWidth: 220, maxWidth: 220 },
            { name: 'Mobile', prop: 'mobile', width: 130, minWidth: 130, maxWidth: 130 },
            { name: 'Status', prop: 'status', width: 100, minWidth: 100, maxWidth: 100, cellTemplate: this.statusTemplate },
            { name: 'Action', prop: 'userid', width: 80, minWidth: 80, maxWidth: 80, sortable: false, cellClass: 'cell-center', cellTemplate: this.editTemplate }
        ];
        this.pageCallback({ offset: 0 });
    }

    pageCallback(pageInfo: { count?: number, pageSize?: number, limit?: number, offset?: number }) {
        this.page.offset = pageInfo.offset;
        this.getTelecallerList();
    }

    sortCallback(sortInfo: { sorts: { dir: string, prop: string }[] }) {
        this.page.orderBy  = sortInfo.sorts[0].prop;
        this.page.orderDir = sortInfo.sorts[0].dir;
        this.getTelecallerList();
    }

    onChangePageSize(limit) {
        this.page.limit = limit;
        this.getTelecallerList();
    }

    onOpenedFilter(): void {
        setTimeout(() => { $('#tcFilterSearch').focus(); }, 100);
    }

    clearFilter(): void {
        this.filterData = { search_data: '' };
        this.applyFilter();
    }

    applyFilter(): void {
        this.filterPanel.close();
        this.page.offset = 0;
        this.getTelecallerList();
    }

    getTelecallerList(): void {
        let params = {
            start: `${this.page.offset}`,
            limit: `${this.page.limit}`,
            orderColumn: `${this.page.orderBy}`,
            orderDir: `${this.page.orderDir}`,
            filter: JSON.stringify(this.filterData)
        };
        this.isLoadMask = this.telecallerMasterService.getTelecallerList(params)
            .then((res: any) => {
                this.loadingIndicator = false;
                this.page.count = res.totCnt;
                this.telecallerList = res.data;
            });
    }

    onAddEditTelecaller(mode: string, row: any): void {
        let that = this;
        this.bsModalRef = this.modalService.show(AddEditTelecallerComponent, {
            keyboard: false,
            ignoreBackdropClick: true,
            class: 'modal-lg maxWidthPer-60'
        });
        row['mode'] = mode;
        this.bsModalRef.content.title = (mode === 'Add' ? 'Add' : 'Edit') + ' Telecaller User';
        let telecallerData = Object.assign({}, row);
        telecallerData['is_mac_address_enable'] = telecallerData['is_mac_address_enable'] === 'Yes' ? true : false;
        this.bsModalRef.content.telecallerdata = telecallerData;
        this.bsModalRef.content.telecallerUpdateEvent.subscribe(() => {
            that.getTelecallerList();
        });
    }

    getSlotColor(slot: string): string {
        return this.slotColors[slot] || '#555';
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/master/telecallerMaster/telecallerMaster.component.ts